




















































import { Component, Vue } from "vue-property-decorator";
import { decode64, SymmetricKey } from "universa-minicrypto";
import { MyoService } from "@/lib/MyoService";
import { UniversalSymmetricKey } from "@/sergecych.uni3/UnversalKeys";
import { Coffer } from "@/sergecych.uni3/Coffer";
import moment, { duration } from "moment";
import { RemoteException } from "@/sergecych.uni3/Parsec";

@Component
export default class ShowPass extends Vue {
  showOverlay = true;
  createdAt = "";
  timestamp = "";
  expired = true;
  firstName = "";
  lastName = "";
  reasonText = "";
  reasonDuration = "";
  licensePlate = "";
  version = "";
  idNumber = "";
  payloadObject: any = {};

  notFound = false;

  expiration = "";
  expiresIn = "";

  interval?: any;
  isValid = false;

  created() {
    console.log(window.location.hash);
    const keyBytes = decode64(window.location.hash);
    console.log(keyBytes);
    const conn = MyoService.connection;
    conn
      .call("getHandle", { id: this.$route.params.id })
      .then(data => {
        console.log("handle loaded", data);
        const simpleKey = new SymmetricKey({ keyBytes });
        const tag = decode64(data.handle.keyInfo);
        const key = new UniversalSymmetricKey(simpleKey, tag);
        const coffer = Coffer.unpack(data.handle.head, key);
        console.log("coffer: ", coffer.payloadObject);
        const q = (this.payloadObject = coffer.payloadObject);
        this.createdAt = moment(data.handle.targetUpdatedAt).format(
          "YYYY-MM-DD HH:mm Z"
        );
        this.timestamp = moment(q.timestamp).format("YYYY-MM-DD HH:mm Z");
        this.firstName = q.firstName;
        this.lastName = q.lastName;
        this.licensePlate = q.licensePlate;
        this.reasonDuration = q.reason.duration;
        this.reasonText = q.reason.text;
        this.version = q.version;
        this.idNumber = q.idNumber;

        console.log(q.timestamp);
        this.calculateTimes();
        this.showOverlay = false;
      })
      .catch(e => {
        if (e instanceof RemoteException) {
          this.notFound = true;
        }
        this.showOverlay = false;
      });
  }

  mounted() {
    if (this.interval) clearInterval(this.interval);
    this.interval = setInterval(() => {
      this.calculateTimes();
    }, 500);
  }

  unmounted() {
    if (this.interval) {
      clearInterval(this.interval);
      this.interval = undefined;
    }
  }

  get fromTo(): moment.Moment[] {
    const q = this.payloadObject;
    const t = q.reason.duration;
    const n = t.slice(0, t.length - 1);
    const u = t.slice(t.length - 1);
    console.log(n, u);
    const s0 = moment(q.timestamp);
    const s1 = moment(q.timestamp).add(n, u);
    return [s0, s1];
  }

  calculateTimes() {
    const [s0, s1] = this.fromTo;
    const now = moment();
    let d = "";

    if (now.isBefore(s0)) {
      this.expiresIn = "not yet started";
      this.isValid = false;
    } else {
      let delta = moment.duration(s1.diff(now));
      let past = false;
      if (now.isAfter(s1)) {
        delta = moment.duration(now.diff(s1));
        past = true;
        this.isValid = false;
      } else this.isValid = true;

      if (delta.asDays() >= 2) d = delta.asDays().toFixed(0) + "d";
      else if (delta.asHours() >= 2) d = delta.asHours().toFixed(0) + "h";
      else d = delta.asMinutes().toFixed(0) + "m";

      this.expiresIn = past ? `expired ${d} ago` : `${d} left`;
    }
    this.expiration = s1.format("YYYY-MM-DD HH:mm Z");
  }

  get expiredClass() {
    return this.isValid ? "text-success" : "text-danger";
  }
}
